import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UInputComponent } from './u-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { UIconModule } from '../u-icon/u-icon.module';
import { AutoFitWidthDirective } from '../../directives/auto-fit-width.directive';
import { UTooltipDirective } from '../../directives/u-tooltip.directive';

const directives = [AutoFitWidthDirective];

@NgModule({
  declarations: [...directives, UInputComponent],
  imports: [CommonModule, FormsModule, InputTextModule, UIconModule, UTooltipDirective, ReactiveFormsModule],
  exports: [...directives, UInputComponent],
})
export class UInputModule {}
